import { css } from '@emotion/react';
import { colors } from 'folio-design-tokens';
import * as React from 'react';

function getCoordinatesForPercent(percent: number) {
  const x = Math.cos(2 * Math.PI * percent);
  const y = Math.sin(2 * Math.PI * percent);
  return [x, y];
}

interface Props {
  size: number;
  value: number;
  backgroundColor?: string;
  sliceColor?: string;
  offset?: number;
}

const Arc: React.FC<{
  value: number;
  color: string;
  offset?: number;
}> = props => {
  if (props.value === 1) {
    return null;
  }
  const realOffset = props.offset || 0;
  const [startX, startY] = getCoordinatesForPercent(realOffset);
  const [endX, endY] = getCoordinatesForPercent(props.value + realOffset);
  const largeArcFlag = props.value > 0.5 ? 1 : 0;

  return (
    <path
      d={`M ${startX} ${startY}
          A 1 1 0 ${largeArcFlag} 1 ${endX} ${endY}
          L 0 0`}
      fill={props.color}
    />
  );
};

export const SimplePie: React.FC<Props> = props => {
  const {
    value,
    size,
    offset = 0,
    backgroundColor = colors.background,
    sliceColor = colors.blue,
  } = props;
  const valid = value > 0 && value <= 1;
  return (
    <svg
      viewBox={`-1 -1 ${size + 2} ${size + 2}`}
      css={css`
        transform: rotate(-90deg);
      `}
      width={size + 2}
      height={size + 2}
    >
      <svg viewBox="-1 -1 2 2" width={size} height={size}>
        {valid ? (
          <>
            <circle
              cx="0"
              cy="0"
              r="1"
              fill={value === 1 ? sliceColor : backgroundColor}
            />
            <Arc value={value} color={sliceColor} offset={offset} />
          </>
        ) : (
          <>
            <circle cx="0" cy="0" r="1" fill={colors.red} />
            <svg viewBox="0 0 18 18" x="-1" y="-1">
              <g fill="#FFF" transform="rotate(90) translate(7.5 -14)">
                <rect width="1.6" height="6.2" x=".7" y=".5" rx=".8" />
                <circle cx="1.5" cy="9.5" r="1" />
              </g>
            </svg>
          </>
        )}
      </svg>
    </svg>
  );
};
